<template>
  <span>

    <button class="btn btn-outline-primary mr-1" @click.prevent="showM=true">hromadné prodloužení expirace</button>

      <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w800">

        <div class="m-head p-3">
          <a class="close"  href=# @click.prevent="showM=false"><span class="material-icons-outlined">close</span></a>
          <h4>Hromadné prodloužení exp</h4>
        </div>

        <div class="modbod p-3">
          <div v-if="group" class="alert alert-info py-2 mb-3">
            Akce se týká pouze skupiny <strong>{{ group.name }}</strong>.
          </div>
          <div class="d-flex">
            <input type="date" id="batch-date-preset" class="form-control" style="" v-model="batch_expiration" />
            <button class="btn-outline-info btn btn-sm" @click="update_expirations">Nastavit</button>
          </div>
          <div><i>Prázdné datum nastaví nekonečnou expiraci</i></div>
        </div>
      </vue-final-modal>

    <button class="btn btn-outline-danger ms-2" @click.prevent="showRemoveM=true">Hromadné vyřazení ze skupiny</button>

    <vue-final-modal v-model="showRemoveM" classes="modal-container" content-class="modal-content-f w600">
      <div class="m-head p-3">
        <a class="close" href="#" @click.prevent="showRemoveM=false">
          <span class="material-icons-outlined">close</span>
        </a>
        <h4>Hromadné vyřazení ze skupiny<span v-if="group"> — {{ group.name }}</span></h4>
      </div>

      <div class="modbod p-3">
        <p class="text-muted mb-3">
          Vybraní studenti budou přesunuti <span v-if="group">ze skupiny <strong>{{ group.name }}</strong></span><span v-else>ze všech skupin</span> do skupiny <strong>Neaktivní studenti</strong>.
          Kurzy zůstanou aktivní.
        </p>

        <div class="mb-3">
          <div class="form-check mb-2">
            <input class="form-check-input" type="radio" id="remove-mode-all" value="all" v-model="removeMode" />
            <label class="form-check-label" for="remove-mode-all">
              Vyřadit všechny studenty <span v-if="group">skupiny</span><span v-else>organizace</span>
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" id="remove-mode-xlsx" value="xlsx" v-model="removeMode" />
            <label class="form-check-label" for="remove-mode-xlsx">
              Vyřadit dle XLSX souboru (1. sloupec = e-mailové adresy)
            </label>
          </div>
        </div>

        <div v-if="removeMode === 'xlsx'" class="mb-3">
          <input type="file" class="form-control" accept=".xlsx,.xls" @change="handleXlsxFile" />
          <div v-if="xlsxEmails.length > 0" class="mt-2 text-success">
            Načteno {{ xlsxEmails.length }} e-mailových adres
          </div>
          <div v-if="xlsxError" class="mt-2 text-danger">{{ xlsxError }}</div>
        </div>

        <div v-if="removeMode === 'all'" class="alert alert-warning py-2">
          <span v-if="group">
            Budou vyřazeni <strong>všichni studenti skupiny {{ group.name }}</strong> ({{ group.students_count || 'N' }} studentů).
          </span>
          <span v-else>
            Budou vyřazeni <strong>všichni studenti</strong> organizace ({{ org.students_count || 'N' }} studentů).
          </span>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-secondary btn-sm" @click.prevent="showRemoveM=false">Zrušit</button>
          <button
            class="btn btn-danger btn-sm"
            @click="confirmRemove"
            :disabled="removeLoading || (removeMode === 'xlsx' && xlsxEmails.length === 0)"
          >
            <span v-if="removeLoading">Spouštím…</span>
            <span v-else>Potvrdit vyřazení</span>
          </button>
        </div>
      </div>
    </vue-final-modal>

    <button class="btn btn-outline-primary ms-2" @click.prevent="openLink">Napojit kurzy na organizaci</button>

    <vue-final-modal v-model="showLinkM" classes="modal-container" content-class="modal-content-f w800">
      <div class="m-head p-3">
        <a class="close" href="#" @click.prevent="showLinkM=false">
          <span class="material-icons-outlined">close</span>
        </a>
        <h4>Napojit kurzy na organizaci<span v-if="group"> — {{ group.name }}</span></h4>
      </div>

      <div class="modbod p-3">
        <p class="text-muted mb-3">
          Placené kurzy z nabídky organizace, které mají studenti <span v-if="group">skupiny</span><span v-else>organizace</span>
          přiřazené bez organizace (např. hromadně doplněné nové verze kurzů). Po napojení na ně zafunguje
          hromadná deaktivace i změna expirace. Platnost kurzů ani studovna se nemění.
        </p>

        <div v-if="linkLoading">Načítám…</div>
        <div v-else-if="linkPreview">
          <div class="alert alert-info py-2">
            Napojí se <strong>{{ linkPreview.linkable }}</strong> kurzů u <strong>{{ linkPreview.students }}</strong> studentů.
          </div>
          <table v-if="linkPreview.by_origin.length" class="table table-sm mb-3">
            <thead><tr><th>Původ kurzu</th><th class="text-end">Počet</th></tr></thead>
            <tbody>
              <tr v-for="row in linkPreview.by_origin" :key="row.info"><td>{{ row.info }}</td><td class="text-end">{{ row.count }}</td></tr>
            </tbody>
          </table>

          <div v-if="linkPreview.purchased > 0" class="alert alert-warning py-2">
            <strong>{{ linkPreview.purchased }}</strong> kurzů vypadá jako soukromý nákup (objednávka, předplatné) a nenapojí se —
            hromadná deaktivace by je studentovi smazala. Napojit se dají ručně na kartě studenta.
            <ul class="mb-0 mt-2 small">
              <li v-for="(row, i) in linkPreview.purchased_sample" :key="i">{{ row.email }} — {{ row.course }}</li>
            </ul>
            <div v-if="linkPreview.purchased > linkPreview.purchased_sample.length" class="small">…a další</div>
          </div>

          <div class="d-flex justify-content-end gap-2 mt-3">
            <button class="btn btn-secondary btn-sm" @click.prevent="showLinkM=false">Zrušit</button>
            <button class="btn btn-primary btn-sm" @click="confirmLink" :disabled="linkLoading || linkPreview.linkable === 0">
              Napojit {{ linkPreview.linkable }} kurzů
            </button>
          </div>
        </div>
      </div>
    </vue-final-modal>

  </span>
</template>

<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import {VueFinalModal} from "vue-final-modal";
import readXlsxFile from "read-excel-file";

export default {
  components: {VueFinalModal},
  name: "organization-helpers",
  props: ['org', 'group'],
  data(){ return {
      batch_expiration: '',
      showM: false,
      // vyřazení ze skupin
      showRemoveM: false,
      removeMode: 'all',
      xlsxEmails: [],
      xlsxError: null,
      removeLoading: false,
      // napojení kurzů na organizaci
      showLinkM: false,
      linkPreview: null,
      linkLoading: false,
    }
  },
  mounted() {
    const csfr_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csfr_token;
    axios.defaults.withCredentials=true
  },
  methods:{
    update_expirations(){
      const url = `/organizations/${this.org.id}/assignments/batch-update-expiration`
      const payload = { date: this.batch_expiration }
      if (this.group) payload.group_id = this.group.id

      axios.put(url, payload).then(response => {

        if (response.status == 200){

          toast('Nastavení se spustilo', {type: 'success'});
          this.showM = false

        }else{

          toast('nic', {type: 'error'});
        }

      }).catch((r)=>{

        toast('chyba: '+ r.response.data.error , {type: 'error'});

      })
    },

    handleXlsxFile(event) {
      this.xlsxEmails = []
      this.xlsxError = null
      const file = event.target.files[0]
      if (!file) return

      readXlsxFile(file).then((rows) => {
        const emails = rows
          .map(row => (row[0] || '').toString().trim().toLowerCase())
          .filter(email => email.includes('@'))
        if (emails.length === 0) {
          this.xlsxError = 'Nebyl nalezen žádný platný e-mail v prvním sloupci.'
        } else {
          this.xlsxEmails = emails
        }
      }).catch(() => {
        this.xlsxError = 'Nepodařilo se načíst soubor. Ujistěte se, že jde o platný XLSX soubor.'
      })
    },

    linkParams() {
      return this.group ? { group_id: this.group.id } : {}
    },

    openLink() {
      this.showLinkM = true
      this.linkPreview = null
      this.linkLoading = true
      axios.get(`/organizations/${this.org.id}/assignments/link_preview`, {params: this.linkParams()}).then((r) => {
        this.linkPreview = r.data
      }).catch((r) => {
        toast('Chyba: ' + (r.response?.data?.error || r.message), {type: 'error'})
        this.showLinkM = false
      }).finally(() => {
        this.linkLoading = false
      })
    },

    confirmLink() {
      this.linkLoading = true
      axios.post(`/organizations/${this.org.id}/assignments/link`, this.linkParams()).then((r) => {
        toast(`Napojeno ${r.data.linked} kurzů.`, {type: 'success'})
        this.showLinkM = false
      }).catch((r) => {
        toast('Chyba: ' + (r.response?.data?.error || r.message), {type: 'error'})
      }).finally(() => {
        this.linkLoading = false
      })
    },

    confirmRemove() {
      this.removeLoading = true
      const payload = this.removeMode === 'xlsx' ? { emails: this.xlsxEmails } : {}
      if (this.group) payload.group_id = this.group.id
      const url = `/organizations/${this.org.id}/mass_remove_from_groups`

      axios.post(url, payload).then(() => {
        toast('Vyřazení ze skupin bylo spuštěno na pozadí.', {type: 'success'})
        this.showRemoveM = false
        this.xlsxEmails = []
        this.removeMode = 'all'
      }).catch((r) => {
        toast('Chyba: ' + (r.response?.data?.error || r.message), {type: 'error'})
      }).finally(() => {
        this.removeLoading = false
      })
    }
  }
}
</script>


<style scoped>
.modal {
  background-color: #f4f4f4;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

}

h4{
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
}

.m-head {
  background-color: #e0e0e0;
  border-bottom: 1px solid #ccc;
}

.modbod {
  padding: 20px;
}

.btn-outline-info {
  color: #17a2b8;
  border-color: #17a2b8;
}

.btn-outline-info:hover {
  background-color: #17a2b8;
  border-color: #17a2b8;
  color: white;
}
</style>
